import {ALL_BASKETBALL_MARKETS} from '../constants/marketTypes';
import {getText} from "../../../../../helpers/localization";


export function getMarketsByCode(marketCode, markets) {
    let marketsByCode = [];
    if (marketCode && markets && markets.length) {
        for (let i = 0; i < markets.length; i++) {

            if (markets[i].id.substring(0, marketCode.code.length) === marketCode.code) {
                marketsByCode.push(markets[i]);
            }
        }
    }
    return marketsByCode;
}

export function areFootballMarketsExpanded(footballMarketsExpanded) {
    let expanded = true;

    if (footballMarketsExpanded && footballMarketsExpanded.length) {
        expanded = footballMarketsExpanded.find((mkt) => mkt === true);
    }
    return expanded;
}

export function translateBasketballUnderOver(text, store) {
    let underOverValue;
    if (text.toLowerCase().split(" ").includes('under')) {
        underOverValue = text.substring(text.toLowerCase().lastIndexOf('under') + 5).trim();
        text = text.replace(underOverValue, '');
        text = text.replace(/\bUnder\b/ig, getText('Under', store, [underOverValue]));
    } else if (text.toLowerCase().indexOf('over') >= 0) {
        underOverValue = text.substring(text.toLowerCase().lastIndexOf('over') + 4).trim();
        text = text.replace(underOverValue, '');
        text = text.replace(/Over /ig, getText('Over', store, [underOverValue]));
    }
    return text;
}

export function translateBasketballUnderOverLanguageBased(text, store) {
    let underOverValue;
    if (text.toLowerCase().split(" ").includes('under')) {
        underOverValue = text.substring(text.toLowerCase().lastIndexOf('under') + 5).trim();
        text = text.replace(underOverValue, '');
        text = text.replace(/\bUnder\b/ig, getText('Short_Under', store, [underOverValue]));
    } else if (text.toLowerCase().indexOf('over') >= 0) {
        underOverValue = text.substring(text.toLowerCase().lastIndexOf('over') + 4).trim();
        text = text.replace(underOverValue, '');
        text = text.replace(/Over /ig, getText('Short_Over', store, [underOverValue]));
    }
    return text;
}

export function getMarketByCode(code) {
    return ALL_BASKETBALL_MARKETS.filter(market => market.code === code.toString())[0];
}


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/basketball/helpers/marketHelpers.js